<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    <div class="flex flex-col items-center">
      <img class="w-full my-10" src="@/assets/logo.png" style="max-width: 50%;"  />
    </div>
  </header>

</template>
